module.exports = __webpack_public_path__ + "assets/img/free_4.259eea75.png";